import { type PickD3Scale } from '@visx/scale';

import type { Parameters } from '@atlaskit/editor-common/extensions';

import type { ParseNumber } from '../../types';

export enum UserLegendPosition {
	AUTO = 'auto',
	TOP = 'top',
	LEFT = 'left',
	RIGHT = 'right',
	BOTTOM = 'bottom',
}

export type LegendPosition = 'top' | 'left' | 'bottom' | 'right' | 'flyout';

export enum Orientation {
	VERTICAL = 'vertical',
	HORIZONTAL = 'horizontal',
}

// Will need to change this back to flat after an update from TWP
export type ChartParameters = Parameters & {
	chartGroup?: {
		customizeTab?: {
			legendField?: {
				legendPosition?: UserLegendPosition;
				showLegend?: string | boolean;
			};
			styleField?: {
				height?: string | number;
				orientation?: Orientation;
				showPoints?: string | boolean;
				smooth?: string | boolean;
			};
			titlesField?: {
				chartTitle?: string;
				xLabel?: string;
				yLabel?: string;
			};
		};
		dataTab?: {
			aggregateData?: string | boolean;
			xAxisIdxField?: string;
			/** pie chart flattens this to a single series **/
			yAxisIdxField?: string[] | string;
		};
	};
	chartType?: ChartTypes;
	/* from Lozenge.tsx */
	extensionTitle?: string;
};

export type ChartsProps = ChartParameters & {
	animated?: boolean;
	data: any;
	localId?: string;
	parseNumber?: ParseNumber;
	/**
	 * A `testId` prop is provided for specified elements, which is a unique
	 * string that appears as a data attribute `data-testid` in the rendered code,
	 * serving as a hook for automated tests */
	testId?: string;
};

export type ChartData = Record<string, number | string | undefined>;

export type ChartComponentProps = {
	aggregateData?: boolean;
	animated: boolean;
	chartScale?: PickD3Scale<'ordinal', any, any>;

	chartType: ChartTypes;
	colorSequence?: string[];
	data: any;
	height: number;
	legendPosition: LegendPosition;
	onLayout?: (layoutOK: boolean) => void;
	orientation?: Orientation;
	parseNumber: ParseNumber;
	showLegend?: boolean;
	showPoints?: boolean;
	smooth?: boolean;
	tableData: ChartData[];
	testId?: string;
	width: number;
	xLabel?: string;

	xSeriesName: string;
	yLabel?: string;

	ySeriesNames: string[];
};

export enum ChartTypes {
	PIE = 'PIE',
	BAR = 'BAR',
	LINE = 'LINE',
}
